import { css } from 'lit';

export const tokens = css`
:host {
  /** ----- header -----  */
  /** height */
  --header-height-with-keyboard: 6rem;
  --header-height: 18rem;

  --block-margin: 3.75rem;
  
  /** ----- questions ------ */
  /** font-size */
  --question-text-size: 2.25rem;
  --question-label-size: 2rem;
  --question-description-size: 2rem;
  --question-input-size: 2rem;
  /** color */
  --question-text-color: var(--c-font-title);
  --current-header-height: 7rem;
  --question-text-color: var(--c-text);
  
  
  /** ----- forms ------ */
  /** inputs */   
  /** font-size */ --input-font-size: 2.5rem;
  /** height */ --input-height: 6.25rem;
  /** padding */ --input-padding: 2rem;
  /** weight */  --input-font-weight: 500;
  
  /** ----- button ------ */
  /** font-size */ --btn-font-size: 2.5rem;
  /** font-size */ --btn-text-size: 2.5rem;
  --btn-note-text-size: 2rem;
  --button-bar-width: unset;
  --button-bar-padding: 0;
  
}
`;